export function playerKindForCamera(camera) {
  const streams = camera.streams || [];
  if (streams.find((x) => x.type === "nexus-webrtc")) return "nexus-webrtc";
  if (streams.find((x) => x.type === "websocket")) return "websocket";
  return "html5";
}

export function createStaggeredPlayScheduler({ staggerMs, onPlay }) {
  const timers = new Map();

  const cancel = (idx) => {
    clearTimeout(timers.get(idx));
    timers.delete(idx);
  };

  const cancelAll = () => {
    timers.forEach((timer) => clearTimeout(timer));
    timers.clear();
  };

  const schedule = (indices) => {
    cancelAll();
    indices.forEach((idx, position) => {
      timers.set(
        idx,
        setTimeout(() => {
          timers.delete(idx);
          onPlay(idx);
        }, position * staggerMs)
      );
    });
  };

  return { schedule, cancel, cancelAll };
}
